import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class KioskService {

  url: string = environment.leads_api;
  token: string = environment.leads_token;
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'token ' + this.token
  });
  constructor(private _http: HttpClient) { }

  createKiosk(device: { 'imei': string, 'model': string }) {
    const api = 'v3/management/kiosk';
    const body = {
      'device': device
    }; 
    
    return this._http.post(`${this.url}/${api}`, body, {
      headers: this.headers
    }).pipe(
      map((d: any) => d.data)
    );
  }

  linkKioskToAccount(b: { accountId: number, kioskId: number }) {
    const api = 'v3/management/kiosk/account/link';
    const body = {
      account_id: b.accountId,
      kiosk_id: b.kioskId
    };
    return this._http.post(`${this.url}/${api}`, body, {
      headers: this.headers
    });
  }

  updateKiosk(id: number, b: { multi_tenant: boolean, timezone: string, nickname: string, cellphone_number: string, company: string, locked: boolean }) {
    const api = `v3/management/kiosk/${id}`;
    const body = {
      multi_tenant: b.multi_tenant,
      timezone: b.timezone,
      cellphone_number: b.cellphone_number,
      nickname: b.nickname,
      company: b.company,
      locked: b.locked
    };

    return this._http.put(`${this.url}/${api}`, body, {
      headers: this.headers
    }).pipe(
      map((d: any) => d.data)
    );
  }

  inviteTenants(b: { tenants: any[], kiosk_id: number }) {
    const api = 'v3/management/kiosk/tenant/invite';

    return this._http.post(`${this.url}/${api}`, b, {
      headers: this.headers
    });
  }

  getKioskByDeviceId(id: number) {
    const api = 'v3/management/kiosk/device';

    return this._http.get(`${this.url}/${api}/${id}`, {
      headers: this.headers
    }).pipe(
      map((d: any) => d.data)
    );
  }

  getKiosks() {
    const api = 'v3/management/kiosks';

    return this._http.get<any>(`${this.url}/${api}`, {
      headers: this.headers
    }).pipe(
      map((d: any) => d.data)
    );
  }

  getKioskDiagnostics(kioskId: number) {
    const api = `v3/management/kiosk/${kioskId}/diagnostics`;

    return this._http.get<any>(`${this.url}/${api}`, {
      headers: this.headers
    }).pipe(
      map((d: any) => d.data)
    );
  }

  decommissionKiosk(kioskId: number) {
    const api = `v3/management/kiosk/${kioskId}/decommission`;

    return this._http.post<any>(`${this.url}/${api}`, {}, {
      headers: this.headers
    }).pipe(
      map((d: any) => d.data)
    );
  }

  migrateKiosk(id: number) {
    const api = `v3/management/kiosk/${id}/migratetomicroservice`;

    return this._http.post<any>(`${this.url}/${api}`, {}, {
      headers: this.headers
    });
  }

  getOldLicenses(id: number) {
    const api = `v3/management/kiosk/${id}/old-licenses`;
    const headers = new HttpHeaders({
      'Authorization': this.token
    });


    return this._http.get<any[]>(`${this.url}/${api}`, {
      headers: this.headers
    }).pipe(
      map((d: any) => d.data),
    );
  }
 
  getFolder(id: number) {
    const api = `v3/management/folder/${id}`;

    return this._http.get<any[]>(`${this.url}/${api}`, {
      headers: this.headers
    }).pipe(
      map((d: any) => d.data),
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/kiosk.service.ts